/* eslint-disable no-param-reassign */

export default (iceConfig) => {
  // to force use TURN
  iceConfig.transportPolicy = 'relay';
  // this needs to be present since it is mandatory prop, but it can be an empty array
  iceConfig.customServers = iceConfig.customServers || [];
};
